import React, { useContext, useEffect, useReducer, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { Button, Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";

import DatePicker from "react-datepicker";

import { ThemeContext } from "../../../../context/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { AddInvoiceApi } from "../../../../service/bankApi/addInvoice";
import { toast, ToastContainer } from "react-toastify";
import { getInvoicesType } from "../../../../service/bankApi/getInvoiceTypes";
import Select from "react-select";
import VerificationTable from "../verificationScreen/verificationTable";
import { UpdateInvoiceApi } from "../../../../service/bankApi/updateInvoice";
import "./verification.scss"
import { getPropertyListApi } from "../../../../service/property/propertyList";
import { getVendorByPropIdApi } from "../../../../service/property/getVendorByProp";
import { getInvoiceByIdApi } from "../../../../service/bankApi/getInvocieById";
import { setLoading } from "../../../../feature/authSlice";
import { findSubMenuByName } from "../../../pages/propertyList/MenuUtlis";
import { VerificationEditTable } from "../verificationScreen/verificationEditTable";
import { approveInvoiceApi } from "../../../../service/bankApi/approveInvoice";
import { cancelInvoiceApi } from "../../../../service/bankApi/cancelInvoice";
import OtpModal from "../../OtpModal/OtpModal";
import { submitForApproval } from "../../../../service/bankApi/submitForApproval";
import { removeDataForInvoiceByEmail } from "../../../../feature/getInvoiceByEmailSlice";
const VerificationEditScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getInvoiceByEmailData = useSelector(state => state.getInvoiceByEmail);

  // const queryParams = new URLSearchParams(location.search);
  // const paramId = queryParams.get('Id');
  const recievedData = location.state;

  const paramId = recievedData.Id
  const [openTab, setOpenTab] = useState(2);
  const [approvedArr, setApprovedArr] = useState([]);
  const [pendingArr, setPendingArr] = useState([]);
  const [permissionModal, setPermissionModal] = useState(false);
  const [cancelInvoiceId, setCancelInvoiceId] = useState("");

  const [permissionModalText, setPermissionModalText] = useState("");
  const [approveInvoiceId, setApproveInvoiceId] = useState(null);
  const [approveFileId, setApproveFileId] = useState(null);
  const [cancelFileId, setCancelFileId] = useState(null);
  const [modaleType, setModalType] = useState(null);
  const [actionPerformArray, setActionPerformArray] = useState([]);

  const [auditDisplay, setAuditDisplay] = useState(false);
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [isApiLaoding, setApiLoading] = useState(false);
  const [totalPagePendingCount, setTotalPendingCount] = useState(0);
  const [totalApprovedCount, setTotalApprovedCount] = useState(0);
  const [totalpendingPaymentCount, setTotalpendingPaymentCount] = useState(0);
  const [totalPaidCount, setTotalPaidCount] = useState(0);
  const [totalRejectedCount, setTotalRejectedCount] = useState(0);
  const [totalUnBillsCount, setTotalUnBillsCount] = useState(0);
  const [defaultTabKey, setDefaultTabKey] = useState("");
  const [reason, setReason] = useState("")
  const [pendingPaymentArr, setPaymentPendingArr] = useState([])
  const [paymentPaidArr, setPaymentPaidArr] = useState([])
  const [rejectedArr, setRejectedArr] = useState([])
  const [unBillsArr, setUnBills] = useState([])
  const [approveArrayData, setApproveArrayData] = useState([])
  const [approveInvoiceModal, setApproveInvoiceModal] = useState(false)
  const [otpModalStatus, setOtpModalStatus] = useState(false)
  const [otpValue, setOtpValue] = useState("")

  const [isEmailInvoice, setIsEmailInvoice] = useState(false);

  const dispatch = useDispatch();
  const columns = [

    {
      Header: "",
      Footer: "Action",
      accessor: "Action",
    },
    {
      Header: "Particular",
      Footer: "Amount",
      accessor: "Particulars" || "particulars",
    },
    {
      Header: "HSN",
      Footer: "Invoice due date",
      accessor: "HSN",
    },
    {
      Header: "Floor",
      Footer: "Floor",
      accessor: "Floor",
    },
    {
      Header: "Unit",
      Footer: "Unit",
      accessor: "Unit",
    },
    {
      Header: "Area",
      Footer: "Area",
      accessor: "Area",
    },
    {
      Header: "Quantity",
      Footer: "Qty",
      accessor: "Qty",
    },
    {
      Header: "Rate",
      Footer: "Rate",
      accessor: "Rate",
    },
    {
      Header: "Amount",
      Footer: "Amount",
      accessor: "Amount",
    },
  ];
  const { changeBackground } = useContext(ThemeContext);
  const { customerId } = useSelector(state => state.auth)
  const [propertiesList, setPropertiesList] = useState([])
  const [selectedPropertyId, setSelectedPropertyId] = useState({

  })
  const [selectedField, setSelectedField] = useState({})
  const [selectedVendorField, setSelectedVendorFeild] = useState({
    value: "",
    label: "Select Vendor"
  })
  const [selectedVendorId, setSelectedVendorId] = useState()
  const [vendorList, setVendorList] = useState([])
  const [selectVendorError, setSelectVendorError] = useState(false)
  const [value, setValue] = useState({})
  const [valuesObj, setValuesObj] = useState({})
  const [invoiceID, setInvoiceId] = useState()
  const [fileIDValue, setFileIdValue] = useState()
  const [tableArr, setTableArr] = useState([]);
  const [amount, setAmount] = useState();
  const [customerAddress, setCustomerAddress] = useState();
  const [customerName, setCustomerName] = useState();
  const [invoiceDate, setInvoiceDate] = useState();
  const [invoiceDueDate, setInvoiceDueDate] = useState();
  const [invoiceNumber, setInvoiceNumber] = useState();
  const [leaseNumber, setLeaseNumber] = useState();
  const [RecieverGstin, setRecieverGstin] = useState();
  const [supplierAddress, setSupplierAddress] = useState();
  const [supplierGstin, setSupplierGstin] = useState();
  const [supplierName, setSupplierName] = useState();
  const [totalAmount, setTotalAmount] = useState();
  const [totalTaxValue, setTotalTaxValue] = useState();
  const [invoiceDateError, setInvoiceDateError] = useState(false);
  const [invoiceDueDateError, setInvoiceDueDateError] = useState(false);
  const [invoiceNumberError, setInvoiceNumberError] = useState(false);
  const [leaseNumberError, setLeaseNumberError] = useState(false);
  const [customerNameError, setCustomerNameError] = useState(false);
  const [customerAddressError, setCustomerAddressError] = useState(false);
  const [supplierNameError, setSupplierNameError] = useState(false);
  const [supplierAddressError, setSupplierAddressError] = useState(false);
  const [supplierGstinError, setSupplierGstinError] = useState(false);
  const [RecieverGstinError, setRecieverGstinError] = useState(false);
  const [totalAmountError, setTotalAmountError] = useState(false);
  const [totalTaxValueError, setTotalTaxValueError] = useState(false);
  const [amountError, setAmountError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fileId, setFileId] = useState();
  const [invoiceType, setInvoiceType] = useState();
  const [invoiceTypeArr, setInvoiceTypeArr] = useState([]);
  const [selectInvoiceTypeError, setSelectInvoiceTypeError] = useState(false);
  const [actionMessage, setActionMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [toaster, setToaster] = useState(false);
  const [updatedArray, setUpdatedArray] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    value: "",
    label: "select property"
  });
  const [selectPropertyIdTypeError, setSelectPropertyIdTypeError] = useState(false)
  const { permissionArr } = useSelector((state) => state.auth);
  const { permissions } = useSelector((state) => state.permissionsData);
  const [locationCode, setLocationCode] = useState('')
  let PropertyId = '';

  const [canApproveFromApi, setCanApproveFromApi] = useState(false);

  useEffect(() => {
    //Check if invoiceId is available by email link
    if (getInvoiceByEmailData) {

      if (recievedData.tab === "Pending for Approval") {
        setCanApproveFromApi(recievedData?.data?.Value?.CanApprove);
      }
      var data = {
        // Id :parseInt(localStorage.getItem("invoiceId"))
        Id: paramId
      }

      if (getInvoiceByEmailData.authorized) {
        data.Id = getInvoiceByEmailData.invoiceId;
        setCanApproveFromApi(true);
        setIsEmailInvoice(true);
        dispatch(removeDataForInvoiceByEmail(null));
        //As Email link will be sent only to those consumers who have approve or reject permission, hence setting by default to true
      }

      let InvoiceData = '';

      if (["", undefined, null].includes(data.Id)) {
        return;
      }

      dispatch(getInvoiceByIdApi(data, (res) => {
        var obj = res.data.result.Value
        setValue(res.data.result)
        setValuesObj(obj)
        setInvoiceId(obj.Id)
        setFileIdValue(obj.FileId)
        setTableArr(res.data.result.TablesValues)
        setAmount(obj.Amount)
        setCustomerAddress(obj.CustomerAddress)
        setCustomerName(obj.CustomerName)
        setInvoiceDate(obj.InvoiceDate)
        setInvoiceDueDate(obj.InvoiceDueDate)
        setInvoiceNumber(obj.InvoiceNo)
        setLeaseNumber(obj.LeaseNo)
        setRecieverGstin(obj.ReceiverGstin)
        setSupplierAddress(obj.SupplierAddress)
        setSupplierGstin(obj.SupplierGstin)
        setSupplierName(obj.SupplierName)
        setTotalAmount(obj.TotalAmount)
        setTotalTaxValue(obj.TotalTaxValue)
        setFileId(obj.FileId)
        setSelectedOption({
          value: obj.InvoiceType,
          label: obj.InvoiceType
        })
        setSelectedVendorId(obj.VendorId)
        InvoiceData = obj
        var propertyPayload = {

          Filter: "status==3",
          OrderBy: "AddressLine1",
          PageSize: 1000,
          PageNumber: 1

        }
        dispatch(getPropertyListApi(propertyPayload, (res) => {
          // const matchedIndex = res.data?.result?.properties.findIndex(address => address.Id === PropertyId);

          //code for matching property Id starts here
          const matchedIndex = res.data?.result?.properties.findIndex(address => address.Id === obj.PropertyId);
          if (matchedIndex != -1) {
            setSelectedField({
              value: res.data?.result?.properties[matchedIndex].Id,
              label: res.data?.result?.properties[matchedIndex].AddressLine1 + " " + res.data?.result?.properties[matchedIndex].AddressLine2 + " " + res.data?.result?.properties[matchedIndex].AddressLine3
            })
            setSelectedPropertyId(res.data?.result?.properties[matchedIndex].Id)
            setLocationCode(res.data?.result.properties[matchedIndex].LocationCode)
            PropertyId = res.data?.result?.properties[matchedIndex].Id
          } else {
            setSelectedPropertyId(0)
            setSelectedField({
              value: "",
              label: "Select Property"
            })
          }
          //code for matching property Id ends here

          setPropertiesList(res.data.result.properties)

        }, (err) => { }))


        var data = {
          propertyId: obj.PropertyId || selectedPropertyId
        }

        dispatch(getVendorByPropIdApi(data, (res) => {
          setVendorList(res.data.result)
          matchVendorId(res.data.result, InvoiceData.VendorId)
          //     const matchedIndex = res.data.result.findIndex(vendor => vendor.Id === InvoiceData.VendorId);

          // if(matchedIndex != -1){
          //   setSelectedVendorFeild(res.data.result[matchedIndex].Id)
          //   setSelectedVendorFeild({
          //     value:res.data.result[matchedIndex].Id,
          //     label:res.data.result[matchedIndex].VendorName  + " " + "("+res.data.result[matchedIndex].VendorGSTIN +")"
          //   })
          // }else{
          //   setSelectedVendorFeild({
          //     value:"",
          //     label:"Select Vendor"
          //   })
          // }

          // if(obj!==null){
          //   matchId(obj)
          // }
        }, (err) => { }))

      }, () => { }))
    }
  }, [paramId, PropertyId, getInvoiceByEmailData])


  function matchVendorId(vendordata, invoiceData) {
    const matchedIndex = vendordata.findIndex(vendor => vendor.Id === invoiceData);
  
    if (vendordata[matchedIndex]?.Id !== null || vendordata[matchedIndex]?.Id !== undefined) {
      // setSelectedVendorFeild(vendordata[matchedIndex].Id)
      setSelectedVendorFeild({
        value: vendordata[matchedIndex]?.Id,
        label: vendordata[matchedIndex]?.VendorName + " " + "(" + vendordata[matchedIndex]?.VendorGSTIN + ")"
      })
    } else {
      setSelectedVendorFeild({
        value: "",
        label: "Select Vendor"
      })
    }
  }

  const notifyTopRight = () => {
    toast.success("✔️ Submit Successfully !!!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };
  const notifyTopRightError = (err) => {
    toast.error(err, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };

  useEffect(() => {
    var data = {
      propertyId: selectedPropertyId
    }

    dispatch(getVendorByPropIdApi(data, (res) => {
      setVendorList(res.data.result)
    }, (err) => {  }))
  }, [selectedPropertyId])


  useEffect(() => {
    dispatch(
      getInvoicesType({}, (res) => {
        setInvoiceTypeArr(res.data.result);
      })
    );
    matchVendorId(vendorList, valuesObj.VendorId)
  }, [selectedPropertyId]);

  const numberOnChange = (number) => {
    if (!isNaN(Number(number))) {
      return true;
    } else {
      return false;
    }
  };
  function convertValue(e) {
    // Parse the string to a Date object
    const originalDate = new Date(e);

    // Extract the components of the date
    const year = originalDate.getFullYear();
    const month = String(originalDate.getMonth() + 1).padStart(2, "0"); // months are zero-based
    const day = String(originalDate.getDate()).padStart(2, "0");
    const hours = String(originalDate.getHours()).padStart(2, "0");
    const minutes = String(originalDate.getMinutes()).padStart(2, "0");
    const seconds = String(originalDate.getSeconds()).padStart(2, "0");
    const milliseconds = String(originalDate.getMilliseconds()).padStart(
      7,
      "0"
    );

    // Get the timezone offset in minutes, then convert to hours and minutes
    const offsetInMinutes = originalDate.getTimezoneOffset();
    const offsetHours = String(
      Math.abs(Math.floor(offsetInMinutes / 60))
    ).padStart(2, "0");
    const offsetMinutes = String(Math.abs(offsetInMinutes % 60)).padStart(
      2,
      "0"
    );
    const offsetSign = offsetInMinutes <= 0 ? "+" : "-";
    const timezoneOffset = `${offsetSign}${offsetHours}:${offsetMinutes}`;

    // Format to desired ISO 8601-like string with milliseconds and timezone
    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${timezoneOffset}`;
    return formattedDate;
  }

  function handleChangeInvoiceData(e) {
    const dataVal = convertValue(e);
    setInvoiceDate(dataVal);
  }

  function handleChangeInvoiceDueData(e) {
    const dataVal = convertValue(e);
    setInvoiceDueDate(dataVal);
  }

  function validateForm() {
    if (
      supplierGstin === "" ||
      supplierGstin === null ||
      RecieverGstin === "" ||
      RecieverGstin === null ||
      totalTaxValue === "" ||
      totalTaxValue === null ||
      totalAmount === "" ||
      totalAmount === null ||
      amount === "" ||
      amount === null ||
      amount == 0 ||
      invoiceDueDate === "" ||
      invoiceDueDate === null ||
      invoiceDate === "" ||
      invoiceDate === null ||
      invoiceNumber === "" ||
      invoiceNumber === null ||
      customerName === "" ||
      customerName === null ||
      customerAddress === "" ||
      customerAddress === null ||
      supplierName === "" ||
      supplierName === null ||
      supplierAddress === "" ||
      supplierAddress === null || selectedPropertyId === 0 || selectedPropertyId === null,
      selectedVendorId === 0 || selectedVendorId === null || selectedVendorId === undefined,
      selectedPropertyId === 0 || selectedPropertyId === null,
      selectedVendorId === 0 || selectedVendorId === null || selectedVendorId === undefined
    ) {
      return false; // At least one condition is not satisfied
    }

    return true; // All conditions are satisfied
  }

  function handleSave() {
    if (selectedOption !== null) {
      const validate = validateForm();
      if (!validate) {
        notifyTopRightError();
        if (supplierGstin === "" || supplierGstin === null) {
          setSupplierGstinError(true);
        }
        if (RecieverGstin === "" || RecieverGstin === null) {
          setRecieverGstinError(true);
        }

        if (totalTaxValue === "" || totalTaxValue === null) {
          setTotalTaxValueError(true);
        }
        if (totalAmount === "" || totalAmount === null) {
          setTotalAmountError(true);
        }

        if (amount === "" || amount === null || amount === 0) {
          setAmountError(true);
        }
        if (invoiceDueDate === "" || invoiceDueDate === null) {
          setInvoiceDueDateError(true);
        }
        if (invoiceDate === "" || invoiceDate === null) {
          setInvoiceDateError(true);
        }
        if (invoiceNumber === "" || invoiceNumber === null) {
          setInvoiceNumberError(true);
        }

        if (customerName === "" || customerName === null) {
          setCustomerNameError(true);
        }
        if (customerAddress === "" || customerAddress === null) {
          setCustomerAddressError(true);
        }

        if (supplierName === "" || supplierName === null) {
          setSupplierNameError(true);
        }
        if (selectedPropertyId === 0 || selectedPropertyId === null) {
          setSelectPropertyIdTypeError(true)
        }
        if (supplierAddress === "" || supplierAddress === null) {
          setSupplierAddressError(true);
        } if (selectedPropertyId === 0 || selectedPropertyId === null) {
          setSelectPropertyIdTypeError(true)
        } if (selectedVendorId === null || selectedVendorId === undefined) {
          setSelectVendorError(true)
        }
      } else {

        setIsLoading(true);
        var dataValue = {
          SupplierGstin: supplierGstin,
          ReceiverGstin: RecieverGstin,
          TotalTaxValue: totalTaxValue,
          TotalAmount: totalAmount,
          Amount: amount,
          InvoiceDueDate: invoiceDueDate,
          InvoiceDate: invoiceDate,
          InvoiceNo: invoiceNumber,
          LeaseNo: leaseNumber,
          CustomerName: customerName,
          CustomerAddress: customerAddress,
          SupplierName: supplierName,
          SupplierAddress: supplierAddress,
          FileId: fileId,
          InvoiceType: selectedOption.label,
          CustomerId: valuesObj.CustomerId,
          PropertyId: selectedPropertyId,
          Status: 0,
          Id: value.Value.Id,
          CreatedOn: value.Value.CreatedOn,
          CreatedBy: value.Value.CreatedBy,
          ModifiedOn: value.Value.ModifiedOn,
          ModifiedBy: value.Value.ModifiedBy,
          DeletedOn: value.Value.DeletedOn,
          InvoiceDetails: updatedArray.length == 0 ? tableArr : updatedArray,
          VendorId: selectedVendorId,
          Remark: valuesObj.Remark,
          IsExpired: valuesObj.IsExpired,
        };

        try {

          dispatch(
            UpdateInvoiceApi(
              dataValue,
              (res) => {
                toast.success("Invoice updated successfully")
                // window.history.go(-1)
                navigate("/invoiceList")
                setIsLoading(false);
              },
              (err) => {
                // notifyTopRightError(err.data.error.exceptionMessage)
                setIsLoading(false);

              }
            )
          );
        } catch (error) {
        }
      }
      // if(false){

      // }
    } else {
      // notifyTopRightError();
      setSelectInvoiceTypeError(true);
    }
    setTimeout(() => {
    }, 500);
    setIsLoading(false)
  }


  function handleValueSelected(e) {
    setSelectInvoiceTypeError(false);
    setSelectedOption(e);
  }
  function handlAddArray() {

    var value = {
      Id: 0,
      InvoiceId: invoiceID,
      Amount: "",
      Area: "",
      BillingCycleFrom: "",
      BillingCycleTo: "",
      CGST: "",
      CGSTAmount: "",
      ConsumptionUnits: "",
      DifferenceUnits: "",
      FileId: fileIDValue,
      Floor: "",
      HSN: "",

      MeterNo: "",
      MeterReadingCurrent: "",
      MeterReadingPrevious: "",
      Particulars: "",
      Qty: "",
      Rate: "",
      SGST: "",
      SGSTAmount: "",
      Unit: "",
    };
    setTableArr([...tableArr, value]);
    toast.success("New row added", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });

  }

  function handleUpdatedArr(data) {
    setTableArr(data);
    const updateData = data
    setUpdatedArray(updateData);
  }
  function handleOnChangeSelectedProperty(e) {
    setSelectPropertyIdTypeError(false)
    setSelectedField(e)
    setSelectedPropertyId(e.value)
    const matchedIndex = propertiesList.findIndex(address => address.Id === e.value);
    if (propertiesList[matchedIndex].LocationCode !== null) {
      setLocationCode(propertiesList[matchedIndex].LocationCode)
    } else {
      setLocationCode('')
    }
  }
  useEffect(() => {
    var data = {

      Filter: "status==3",
      OrderBy: "AddressLine1",
      PageSize: 1000,
      PageNumber: 1

    }
    dispatch(getPropertyListApi(data, (res) => {
      const matchedIndex = res.data?.result?.properties.findIndex(address => address.Id === PropertyId);


      setPropertiesList(res.data.result.properties)

    }, (err) => { }))
  }, [])
  useEffect(() => {
    // matchId()
    // matchIdVendor()

  }, [propertiesList])

  function matchId(value) {
    const matchedIndex = propertiesList.findIndex(address => address.Id === value.PropertyId);

    if (matchedIndex != -1) {
      setSelectedField({
        value: propertiesList[matchedIndex].Id,
        label: propertiesList[matchedIndex].AddressLine1 + " " + propertiesList[matchedIndex].AddressLine2 + " " + propertiesList[matchedIndex].AddressLine3
      })
      setSelectedPropertyId(propertiesList[matchedIndex].Id)
    } else {
      setSelectedPropertyId(0)
      setSelectedField({
        value: "",
        label: "Select Property"
      })
    }
  }

  function handleOnChangeSelectedVendor(e) {
    setSelectVendorError(false)
    setSelectedVendorFeild(e)
    setSelectedVendorId(e.value)
  }

  // Helper function to check if a specific action exists in a submenu
  const hasAction = (submenu, actionName) => submenu?.Actions.includes(actionName);


  // Find the "Invoice" menu
  const invoiceMenu = findSubMenuByName(permissions, 'Invoice');
  const invoiceListMenu = invoiceMenu ? findSubMenuByName(invoiceMenu?.SubMenus, 'Invoice List') : null;
  const newSubMenu = invoiceListMenu ? findSubMenuByName(invoiceListMenu?.SubMenus, recievedData.tab) : null;
  const editSubMenu = newSubMenu ? findSubMenuByName(newSubMenu?.SubMenus, 'Edit') : null;

  // Check if "Update" action exists in the "Edit" submenu
  let canUpdate = editSubMenu ? hasAction(editSubMenu, 'Update') : false;
  const canApprove = editSubMenu ? hasAction(editSubMenu, 'Approve') : false;
  const canReject = editSubMenu ? hasAction(editSubMenu, 'Reject') : false;
  const canSubmitForApproval = editSubMenu ? hasAction(editSubMenu, 'SubmitForApproval') : false;

  const datePickerRef = useRef(null);
  const datePickerDueRef = useRef(null);


  const openDatePicker = (ref) => {
    if (ref.current) {
      ref.current.setOpen(true);
    }
  };


  function handleApproveCalled() {
    setApiLoading(true)
    var data = [{
      InvoiceId: recievedData?.data?.Value?.Id,
      FileId: recievedData?.data?.Value?.FileId,
    }];
    var data = {
      ResendOtp: false,
      OTP: otpValue,
      approveList: data
    }
    dispatch(
      approveInvoiceApi(
        data,
        (res) => {
          setApiLoading(false)
          setPermissionModal(false);
          // window.history.go(-1)
          // onLoadData();
          // notifyTopRight();
        },
        (err) => { setApiLoading(false) }
      )
    );
  }

  function handleMultipleApproveCalled() {
    setApiLoading(true)
    var data = [{
      // InvoiceId: recievedData?.data?.Value?.Id,
      // FileId: recievedData?.data?.Value?.FileId,

      InvoiceId: invoiceID,
      FileId: fileId

    }];

    var data = {
      ResendOtp: false,
      OTP: otpValue,
      approveList: data
    }

    try {
      dispatch(
        approveInvoiceApi(
          data,
          (res) => {
            setApiLoading(false)

            if (res.data.result.ResponseMessage === "OTP sent successfully") {
              setOtpModalStatus(true)
              setPermissionModal(false);
              setApproveInvoiceModal(false);
              toast.success(res.data.result.ResponseMessage)

            } else {
              setOtpValue("")
              setOtpModalStatus(false)
              setApproveInvoiceModal(false);
              if (isEmailInvoice) {
                navigate("/");
              } else {
                window.history.go(-1)
              }

              // notifyTopRight();
              toast.success("✔️ Approved successfully")

            }



          },
          (err) => {
            setApiLoading(false)

          }
        )
      );
    } catch (error) {

    }
  }

  function handleApproveInvoiceOtp(element) {
    setOtpValue(element);
  }

  function handleResendOtp() {

    var data = {
      ResendOtp: true,
      OTP: "",
      approveList: approveArrayData
    }

    try {
      dispatch(
        approveInvoiceApi(
          data,
          (res) => {
            toast.success(res.data.result.ResponseMessage)
          },
          (err) => {
          }
        )
      );
    } catch (error) {

    }
  }
  function handleCancelCalled() {

    setApiLoading(true)
    var data = {
      // InvoiceId: recievedData?.data?.Value?.Id,
      // FileId: recievedData?.data?.Value?.FileId,
      InvoiceId: invoiceID,
      FileId: fileId,
      RejectionReason: reason
    };
    if (reason !== '') {
      try {
        dispatch(
          cancelInvoiceApi(
            data,
            (res) => {
              // onLoadData();
              if (isEmailInvoice) {
                navigate("/");
              } else {
                window.history.go(-1)
              }
              setApiLoading(false)
              setReason('')
              setPermissionModal(false);
              toast.success("✔️ Invoice rejected successfully")
            },
            (err) => {
              setApiLoading(false)

              setReason('')
            }
          )
        );
      } catch (error) {

        setReason('')
      }
    }
    else {
      toast.error('Please provide a reason')
    }

  }

  function handleInvoiceAcceptReject(action) {
    if (action == "cancel") {
      setModalType(0);
      setPermissionModal(true);
      // setCancelInvoiceId(data.Id);
      // setCancelFileId(data.FileId);
    } else if (action == "approve") {
      setModalType(1);
      setPermissionModal(true);
      // setApproveInvoiceId(data.Id);
      // setApproveFileId(data.FileId);
    }
  }

  const [submitForApproveInvoiceModal, setSubmitForApproveInvoiceModal] = useState(false)
  function handleActionMultipleSubmitForApprove(data) {
    setSubmitForApproveInvoiceModal(true)
  }

  function handleMultipleSubmitForApproveCalled() {
    setApiLoading(true)

    // const data = submitForApprovalArrayData.map((item) => item.InvoiceId);
    const data = [

      recievedData?.data?.Value?.Id
    ];

    try {
      dispatch(
        submitForApproval(
          data,
          (res) => {
            setApiLoading(false)
            if (res.data.message === "POST Request successful.") {
              setSubmitForApproveInvoiceModal(false);
              // window.history.go(-1)
              navigate("/invoiceList")
              toast.success("Submitted for approval successfully.")
            } else {
              setSubmitForApproveInvoiceModal(false);
              // onLoadData();
            }
          },
          (err) => {
            setApiLoading(false)
          }
        )
      );
    } catch (error) {

    }
  }

  return (
    <>
      <ToastContainer />
      {/* {  toaster && <AutohideToaster action={actionMessage} message={message} handleFucntion={()=>{setToaster(false)}}/>} */}
      <div className="row d-flex justify-content-between">
        {/* <BalanceCardSlider /> */}
        <div className="col-xl-6">
          <div className="card h-auto">
            <div
              className="card-body px-0 pt-1"
              style={{ maxHeight: "741px", overflowY: "auto" }}
            >
              <Tab.Container defaultActiveKey="Form">
                <div className="card-header border-0 pb-2 flex-wrap">
                  <div className="d-flex">
                    <i className="material-icons" style={{ cursor: 'pointer', marginRight: '12px', marginTop: '1px' }} onClick={() => {
                      if (isEmailInvoice) {
                        navigate("/")
                      } else {
                        window.history.go(-1)
                      }
                    }}>chevron_left</i>
                    <h4 className="heading me-2"> Verification</h4>
                  </div>
                  <nav>
                    <Nav as="div" className="order nav nav-tabs" role="tablist">
                      <Nav.Link
                        as="button"
                        eventKey="Form"
                      // onClick={() => {
                      //   setOpenTab(1);
                      // }}
                      >
                        Form
                      </Nav.Link>
                      <Nav.Link
                        as="button"
                        eventKey="Table"
                      // onClick={() => {
                      //   setOpenTab(2);
                      // }}
                      >
                        Table
                      </Nav.Link>
                    </Nav>
                  </nav>
                </div>
                <div className="">
                  <Tab.Content>
                    <Tab.Pane eventKey="Form">
                      <Tab.Container>
                        <div className="sell-element">
                          <div className=" col-lg-12">
                          <div style={{
  position: "fixed",
  bottom: "20px",
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  gap: "10px",
  zIndex: 1000
}}>
                            {canUpdate &&
                              <button
                                disabled={canUpdate ? false : true}
                                className="btn btn-primary"
                                style={{
                                  background: "rgba(233, 133, 35,1)",
                                  border: "none",
                                }}
                                onClick={() => {
                                  handleSave();
                                }}
                              >
                                {isLoading ? "Updating..." : "Update"}
                              </button>
                            }
                            {canSubmitForApproval && (
                              <button
                                disabled={canSubmitForApproval ? false : true}
                                className="btn btn-primary"
                                style={{
                                  background: "rgba(233, 133, 35,1)",
                                  border: "none",
                                  marginLeft: '10px'
                                }}
                                onClick={() => handleActionMultipleSubmitForApprove()}
                              >
                                {isLoading ? "Submitting For Approval..." : "Submit For Approval"}
                              </button>
                            )}
                            {canApprove && (
                              <button
                                disabled={canApproveFromApi ? false : true}
                                className="btn btn-primary"
                                style={{
                                  background: "rgba(233, 133, 35,1)",
                                  border: "none",
                                  marginLeft: '10px'
                                }}
                                onClick={() => handleInvoiceAcceptReject("approve")}
                              >
                                {isLoading ? "Approving..." : "Approve"}
                              </button>
                            )}
                            {(recievedData?.tab === "New" || recievedData?.tab === "Pending for Approval") && (
                           <button
                           disabled={canReject ? false : true}
                           className="btn btn-primary"
                           style={{
                             background: "rgba(233, 133, 35,1)",
                             border: "none",
                             marginLeft: '10px',
                           }}
                           onClick={() => handleInvoiceAcceptReject("cancel")}
                         >
                           {isLoading ? "Rejecting..." : "Reject"}
                         </button>
                            )}
                        </div>
                            <div className="card-body" style={{marginTop:'-25px'}}>
                            <div className="basic-form">
                                <form onSubmit={(e) => e.preventDefault()}>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Property
                                    </label>
                                    <div className="col-sm-9">
                                      <Select
                                        isDisabled={canUpdate ? false : true}
                                        value={selectedField}
                                        onChange={handleOnChangeSelectedProperty}
                                        placeholder="Select Invoice Type"
                                        options={propertiesList.map(item => ({
                                          value: item.Id,
                                          label: item.LocationName + " - " + item.AddressLine1 + " " + item.AddressLine2 + " " + item.AddressLine3
                                        }))}

                                      />
                                      {selectPropertyIdTypeError && (
                                        <p className="text-danger">
                                          Please select property
                                        </p>
                                      )}

                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Vendor
                                    </label>
                                    <div className="col-sm-9">
                                      <Select
                                        isDisabled={canUpdate ? false : true}
                                        value={selectedVendorField}
                                        onChange={handleOnChangeSelectedVendor}
                                        placeholder="Select Invoice Type"
                                        options={vendorList.map(item => ({
                                          value: item.Id,
                                          label: item.VendorName + " " + "(" + item.VendorGSTIN + ")"
                                        }))}

                                      />
                                      {selectVendorError && (
                                        <p className="text-danger">
                                          Please select vendor
                                        </p>
                                      )}

                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Invoice Type
                                    </label>
                                    <div className="col-sm-9">
                                      <Select
                                        isDisabled={canUpdate ? false : true}
                                        value={selectedOption}
                                        onChange={handleValueSelected}
                                        placeholder="Select Invoice Type"
                                        options={invoiceTypeArr.map((item) => ({
                                          value: item.Id,
                                          label: item.Name,
                                        }))}
                                      />
                                      {selectInvoiceTypeError && (
                                        <p className="text-danger">
                                          Please select invoice type
                                        </p>
                                      )}
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Invoice Number
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        disabled={canUpdate ? false : true}
                                        className="form-control"
                                        value={invoiceNumber}
                                        onChange={(e) => {
                                          setInvoiceNumberError(false);
                                          setInvoiceNumber(e.target.value);
                                        }}
                                      />
                                      {invoiceNumberError && (
                                        <p className="text-danger">
                                          Please enter valid invoice number
                                        </p>
                                      )}
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Invoice date
                                    </label>
                                    <div className="col-sm-8">
                                      <DatePicker
                                        ref={datePickerRef}
                                        disabled={canUpdate ? false : true}
                                        className="form-control"
                                        value={invoiceDate?.split("T")[0]}
                                        onChange={(e) => {
                                          handleChangeInvoiceData(e);
                                          setInvoiceDateError(false);
                                        }}
                                      />
                                      {invoiceDateError && (
                                        <p className="text-danger">
                                          Please enter valid invoice date
                                        </p>
                                      )}
                                    </div>
                                    <div className="col-sm-1" onClick={() => openDatePicker(datePickerRef)} >
                                      <i class="material-icons">
                                        calendar_month
                                      </i>
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Invoice due date
                                    </label>
                                    <div className="col-sm-8">
                                      <DatePicker
                                        ref={datePickerDueRef}
                                        disabled={canUpdate ? false : true}
                                        className="form-control"
                                        value={invoiceDueDate?.split("T")[0]}
                                        onChange={(e) => {
                                          handleChangeInvoiceDueData(e);
                                          setInvoiceDueDateError(false);
                                        }}
                                      />
                                      {invoiceDueDateError && (
                                        <p className="text-danger">
                                          Please enter valid invoice due date
                                        </p>
                                      )}
                                    </div>
                                    <div className="col-sm-1" onClick={() => openDatePicker(datePickerDueRef)}>
                                      <i class="material-icons">
                                        calendar_month
                                      </i>
                                    </div>
                                  </div>
                                  {/* 2 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Customer Name
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        disabled={canUpdate ? false : true}
                                        className="form-control"
                                        value={customerName}
                                        onChange={(e) => {
                                          setCustomerName(e.target.value);
                                          setCustomerNameError(false);
                                        }}
                                      />
                                      {customerNameError && (
                                        <p className="text-danger">
                                          Please enter valid customer name
                                        </p>
                                      )}
                                    </div>
                                  </div>

                                  {/* 3 */}

                                  {/* 4 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Customer Address
                                    </label>
                                    <div className="col-sm-9">
                                      <textarea
                                        disabled={canUpdate ? false : true}
                                        className="form-txtarea form-control"
                                        rows="4"
                                        id="comment"
                                        value={customerAddress}
                                        onChange={(e) => {
                                          setCustomerAddress(e.target.value);
                                          setCustomerAddressError(false);
                                        }}
                                      ></textarea>
                                      {customerAddressError && (
                                        <p className="text-danger">
                                          {" "}
                                          Please enter valid customer address
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Location Code
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        disabled
                                        className="form-control"
                                        value={locationCode}
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Customer GSTIN
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        disabled={canUpdate ? false : true}
                                        className="form-control"
                                        value={RecieverGstin}
                                        onChange={(e) => {
                                          setRecieverGstinError(false);
                                          setRecieverGstin(e.target.value);
                                        }}
                                      />
                                      {RecieverGstinError && (
                                        <p className="text-danger">
                                          Please enter valid reciever gstin
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  {/* 5 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Supplier Name
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        disabled={canUpdate ? false : true}
                                        className="form-control"
                                        value={supplierName}
                                        onChange={(e) => {
                                          setSupplierNameError(false);
                                          setSupplierName(e.target.value);
                                        }}
                                      />
                                      {supplierNameError && (
                                        <p className="text-danger">
                                          Please enter valid supplier name
                                        </p>
                                      )}
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Supplier address
                                    </label>
                                    <div className="col-sm-9">
                                      <textarea
                                        disabled={canUpdate ? false : true}
                                        className="form-txtarea form-control"
                                        rows="4"
                                        id="comment"
                                        value={supplierAddress}
                                        onChange={(e) => {
                                          setSupplierAddressError(false);
                                          setSupplierAddress(e.target.value);
                                        }}
                                      ></textarea>
                                      {supplierAddressError && (
                                        <p className="text-danger">
                                          {" "}
                                          Please enter valid supplier address
                                        </p>
                                      )}
                                    </div>
                                  </div>

                                  {/* 6 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Supplier GSTIN
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        disabled={canUpdate ? false : true}
                                        className="form-control"
                                        value={supplierGstin}
                                        onChange={(e) => {
                                          setSupplierGstinError(false);
                                          setSupplierGstin(e.target.value);
                                        }}
                                      />
                                      {supplierGstinError && (
                                        <p className="text-danger">
                                          {" "}
                                          Please enter valid supplier gstin
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  {/* 7 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black" >
                                      Amount
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        disabled={canUpdate ? false : true}
                                        className="form-control"
                                        value={amount}
                                        onChange={(e) => {
                                          // numberOnChange(e.target.value) &&
                                          //   setAmount(e.target.value);
                                          // setAmountError(false);
                                          const newValue = e.target.value;

                                          // Check if the input is a valid number
                                          if (numberOnChange(newValue) && (newValue === '' || Number(newValue) >= 0)) {
                                            setAmount(newValue);
                                            setAmountError(false);
                                          } else {
                                            setAmountError(true); // Optionally set an error state if invalid
                                          }
                                        }}
                                      />
                                      {amountError && (
                                        <p className="text-danger">
                                          Please enter valid amount
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  {/* 8 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Tax Amount
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        disabled={canUpdate ? false : true}
                                        className="form-control"
                                        value={totalTaxValue}
                                        onChange={(e) => {
                                          numberOnChange(e.target.value) &&
                                            setTotalTaxValue(e.target.value);
                                          setTotalTaxValueError(false);
                                        }}
                                      />
                                      {totalTaxValueError && (
                                        <p className="text-danger">
                                          Please enter valid total tax value
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  {/* 9 */}

                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label">
                                      Total Amount
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        disabled={canUpdate ? false : true}
                                        className="form-control"
                                        value={totalAmount}
                                        onChange={(e) => {
                                          // numberOnChange(e.target.value) &&
                                          //   setTotalAmount(e.target.value);
                                          // setTotalAmountError(false);
                                          const newValue = e.target.value;

                                          // Check if the input is a valid number and non-negative
                                          if (numberOnChange(newValue) && (newValue === '' || Number(newValue) >= 0)) {
                                            setTotalAmount(newValue);
                                            setTotalAmountError(false);
                                          } else {
                                            setTotalAmountError(true); // Optionally set an error state if invalid
                                          }
                                        }}
                                      />
                                      {totalAmountError && (
                                        <p className="text-danger">
                                          Please enter valid total amount
                                        </p>
                                      )}
                                    </div>
                                  </div>


                                  {/* 
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label">
                                      Lease no
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                        className="form-control"
                                        value={leaseNumber}
                                        onChange={(e) => {
                                          setLeaseNumber(e.target.value);
                                          setLeaseNumberError(false);
                                        }}
                                      />
                                      {leaseNumberError && (
                                        <p className="text-danger">
                                          Please enter valid lease number
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                 
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label">
                                      Supplier address
                                    </label>
                                    <div className="col-sm-9">
                                      <textarea
                                        className="form-txtarea form-control"
                                        rows="4"
                                        id="comment"
                                        value={supplierAddress}
                                        onChange={(e) => {
                                          setSupplierAddressError(false);
                                          setSupplierAddress(e.target.value);
                                        }}
                                      ></textarea>
                                      {supplierAddressError && (
                                        <p className="text-danger">
                                          {" "}
                                          Please enter valid supplier address
                                        </p>
                                      )}
                                    </div>
                                  </div> */}
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab.Container>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Table">
                      <Tab.Container>
                        <Tab.Content id="nav-tabContent1"></Tab.Content>
                        {tableArr?.length > 0 && <VerificationEditTable
                          column={columns}
                          rowsArr={tableArr}
                          addNewRow={() => {
                            handlAddArray();
                          }}
                          updatedArray={handleUpdatedArr}
                          handleSave={handleSave}
                          isLoading={isLoading}
                          buttonLoading={"Updating"}
                          buttonName={"Update"}
                        />}
                      </Tab.Container>
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
        <Modal className="fade" show={permissionModal} centered>
          <Modal.Header>
            <Modal.Title> {modaleType === 0 ? "Please provide reason :-" : "Alert"}</Modal.Title>
            <Button
              onClick={() => setPermissionModal(false)}
              variant=""
              className="btn-close"
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <p className="text-black">
              {modaleType === 0 ? (
                <>
                  <div className="ps-1 align-self-center">
                    <div className="custom-control custom-checkbox d-flex flex-column ">
                      <label
                        className="custom-control-label"
                        style={{ margin: "0px", color: 'black' }}
                      >

                        Reason
                      </label>
                      <textarea className="form-control" style={{ minHeight: '112px' }} value={reason} onChange={(e) => setReason(e.target.value)}>

                      </textarea>

                      &nbsp; &nbsp;

                    </div>
                  </div>


                </>
              ) : (
                "Are you sure you want to approve this invoice?"
              )}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => setPermissionModal(false)}
              variant="danger light"
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={modaleType == 0 ? handleCancelCalled : handleMultipleApproveCalled}
            >
              {isApiLaoding ? "Proceeding" : "Proceed"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal className="fade" show={approveInvoiceModal} centered>
          <Modal.Header>
            <Modal.Title> Approve Invoice</Modal.Title>
            <Button
              onClick={() => setApproveInvoiceModal(false)}
              variant=""
              className="btn-close"
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <p className="text-black">

              Are you sure you want to approve these invoices ?

            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => setApproveInvoiceModal(false)}
              variant="danger light"
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => { handleMultipleApproveCalled() }}
              disabled={isApiLaoding}
            >
              {isApiLaoding ? "Proceeding" : "Proceed"}
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="col-xl-6">
          <div className="card h-auto">
            <div className="card-body px-0 pt-1" style={{ overflowY: "auto" }}>
              <Tab.Container defaultActiveKey="Navbuy">
                <div className="">
                  <Tab.Content>
                    <Tab.Pane eventKey="Navbuy">
                      <iframe
                        src={value?.FilePath}
                        width="100%"
                        height={"700px"}
                      ></iframe>
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
      {
        otpModalStatus && <OtpModal
          otpModal={otpModalStatus}
          otp={otpValue}
          handleOtpChange={handleApproveInvoiceOtp}
          handleModalClose={() => {
            setOtpValue("")
            setOtpModalStatus(false)
          }}
          handleProceed={handleMultipleApproveCalled}
          resendOtp={handleResendOtp}
        />
      }

      <Modal className="fade" show={submitForApproveInvoiceModal} centered>
        <Modal.Header>
          <Modal.Title> Submit For Approval</Modal.Title>
          <Button
            onClick={() => setSubmitForApproveInvoiceModal(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p className="text-black">

            Are you sure you want to submit these invoices for approval?

          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setSubmitForApproveInvoiceModal(false)}
            variant="danger light"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => { handleMultipleSubmitForApproveCalled() }}
            disabled={isApiLaoding}
          >
            {isApiLaoding ? "Proceeding" : "Proceed"}
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
};
export default VerificationEditScreen;
